import { Configuration } from '../runtime';
import { IInitializeServiceOptions } from '../types';
import { ElasticService } from './ElasticService';
import { Data360ExplorerApi } from './generated/apis/Data360ExplorerApi';
import { ExportApi } from './generated/apis/ExportApi';
import { HybridSearchApi } from './generated/apis/HybridSearchApi';

export const initializeSearchService = ({ fetchApi, serviceBaseURLs, tenantId }: IInitializeServiceOptions) => {
	const hybridSearchApi = new HybridSearchApi(new Configuration({ fetchApi, basePath: serviceBaseURLs['ccgf-searchv2'] }));
	const exportApi = new ExportApi(new Configuration({ fetchApi, basePath: serviceBaseURLs['ccgf-searchv2'] }));
	const data360ExplorerApi = new Data360ExplorerApi(new Configuration({ fetchApi, basePath: serviceBaseURLs['ccgf-searchv2'] }));

	return {
		hybridSearchApi,
		exportApi,
		data360ExplorerApi,
		elasticService: new ElasticService(hybridSearchApi, tenantId),
	};
};
